import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';

export const functions_booker = {

    data: function () {
        return {
            booker_hotels_loaded: false,
            booker_rooms_loaded: false,
            booker_tarifs_loaded: false,
            booker_hotels: [],
            booker_rooms: [],
            booker_tarifs: [],
        };
    },

    computed: {
    },

    methods: {
        loadBookerHotels: function (booker_id, onSuccess=null, param=null) {
            if (this.isBookerHotelsPreloaded(booker_id)) { this.executeFunction(onSuccess, param); return this; }
            this.booker_hotels_loaded = false;
            this.booker_hotels = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('booker/'+booker_id+'/hotels')).then(function (response) {
                response = this.httpSuccess(response);
                this.booker_hotels = response.payload;
                this.$store.commit('savePreloadBookerHotels', {booker_id:booker_id,booker_hotels:this.booker_hotels});
                this.booker_hotels_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        isBookerHotelsPreloaded: function (booker_id) {
            return false;
            if (!this.is(this.$store.state.pl.booker_hotels[booker_id])) { return false; }
            this.booker_hotels = this.$store.state.pl.booker_hotels[booker_id];
            return true;
        },

        loadBookerRooms: function (booker_id, hotel_id, onSuccess=null, param=null) {
            if (this.isBookerRoomsPreloaded(booker_id, hotel_id)) { this.executeFunction(onSuccess, param); return this; }
            this.booker_rooms_loaded = false;
            this.booker_rooms = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('booker/'+booker_id+'/'+hotel_id+'/rooms')).then(function (response) {
                response = this.httpSuccess(response);
                this.booker_rooms = response.payload;
                console.log('booker_id=',booker_id)
                console.log('hotel_id=',hotel_id)
                console.log('booker_rooms=',this.booker_rooms)
                this.$store.commit('savePreloadBookerRooms', {booker_id:booker_id,hotel_id:hotel_id,booker_rooms:this.booker_rooms});
                this.booker_rooms_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        isBookerRoomsPreloaded: function (booker_id, hotel_id) {
            return false;
            if (!this.is(this.$store.state.pl.booker_rooms[booker_id+'--'+hotel_id])) { return false; }
            this.booker_hotels = this.$store.state.pl.booker_rooms[booker_id+'--'+hotel_id];
            return true;
        },

        loadBookerPrograms: function (booker_id, hotel_id, onSuccess=null, param=null) {
            if (this.isBookerTarifsPreloaded(booker_id, hotel_id)) { this.executeFunction(onSuccess, param); return this; }
            this.booker_tarifs_loaded = false;
            this.booker_tarifs = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('booker/'+booker_id+'/'+hotel_id+'/programs')).then(function (response) {
                response = this.httpSuccess(response);
                this.booker_tarifs = response.payload;
                console.log('booker_id=',booker_id)
                console.log('hotel_id=',hotel_id)
                console.log('booker_tarifs=',this.booker_tarifs)
                this.$store.commit('savePreloadBookerPrograms', {booker_id:booker_id,hotel_id:hotel_id,booker_tarifs:this.booker_tarifs});
                this.booker_tarifs_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        isBookerTarifsPreloaded: function (booker_id, hotel_id) {
            return false;
            if (!this.is(this.$store.state.pl.booker_tarifs[booker_id+'--'+hotel_id])) { return false; }
            this.booker_hotels = this.$store.state.pl.booker_tarifs[booker_id+'--'+hotel_id];
            return true;
        }
    }
};

